import { Navigate, Outlet, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { userCanAccessFirm } from '../utils/firmAccess';

/**
 * Firm URLs are limited to members of that firm, plus PMP and site admins.
 */
const FirmMemberRoute = () => {
  const { firmId } = useParams();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!userCanAccessFirm(user, firmId)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default FirmMemberRoute;
